import * as layout from '../../components/markLayout.module.css';
import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Section from '@hero/ui-kit/layout/Section';
import H from '@hero/ui-kit/typography/H';
import P from '@hero/ui-kit/typography/P';
import BackButton from '../../../../components/BackButton';
import InlineLoader from '../../../../components/InlineLoader';
import QueryInlineError from '../../../../components/QueryInlineError';
import useDrip from '../../api/useDrip';
import useBack from '../../../../hooks/useBack';
import StepCanvas from './StepCanvas';
const VersionView: React.FC = () => {
    const { dripId, versionNumber } = useParams<{
        dripId: string;
        versionNumber: string;
    }>();
    const back = useBack();
    const numericDripId = Number(dripId);
    const numericVersion = Number(versionNumber);
    const validParams =
        Number.isInteger(numericDripId) &&
        numericDripId > 0 &&
        Number.isInteger(numericVersion) &&
        numericVersion > 0;
    const {
        data: dripResponse,
        isLoading,
        error
    } = useDrip(validParams ? numericDripId : 0, validParams ? numericVersion : undefined);
    const drip = dripResponse?.data;
    const version =
        drip?.draft_version?.version_number === numericVersion
            ? drip.draft_version
            : drip?.current_version?.version_number === numericVersion
              ? drip.current_version
              : null;
    if (!validParams) {
        return (
            <Section subtheme={['regular', 'background']} className={layout.page} noDefaultPadding>
                <P>Version not found.</P>
            </Section>
        );
    }
    if (isLoading) return <InlineLoader />;
    if (error) return <QueryInlineError error={error} />;
    if (!drip || !version) return <P>Version not found.</P>;
    return (
        <Section subtheme={['regular', 'background']} className={layout.page} noDefaultPadding>
            <BackButton onBack={() => back(`/mark/drips/${numericDripId}`)} alt="Back to drip" />
            <P
                noDefaultMargin
                size="small"
                styles={{
                    margin: '0.8rem 0',
                    color: 'var(--mark-muted)'
                }}
            >
                <Link
                    to="/mark"
                    style={{
                        color: 'inherit'
                    }}
                >
                    Mark
                </Link>
                {' > '}
                <Link
                    to="/mark/drips"
                    style={{
                        color: 'inherit'
                    }}
                >
                    Drips
                </Link>
                {' > '}
                <Link
                    to={`/mark/drips/${numericDripId}`}
                    style={{
                        color: 'inherit'
                    }}
                >
                    {drip.name}
                </Link>
                {' > '}v{numericVersion}
            </P>
            <H role="h5">{`${drip.name} — v${numericVersion}`}</H>
            <div
                role="alert"
                style={{
                    backgroundColor: 'var(--mark-warning-surface)',
                    marginBottom: '1.2rem'
                }}
                className={layout.notice}
            >
                <P
                    noDefaultMargin
                    size="small"
                    styles={{
                        color: 'var(--mark-warning)'
                    }}
                >
                    Read-only view of v{numericVersion}. To edit, use the current draft.
                </P>
            </div>
            <StepCanvas steps={version.steps} entryStepId={version.entry_step_id} />
        </Section>
    );
};
export default VersionView;
